import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   component: () =>
    //         import ('@/components/Home.vue')
    // },
    {
      path: '/',
      name: 'login',
      component: () =>
            import ('@/components/Login.vue')
    },
    {
      path: '/input',
      name: 'input',
      component: () =>
            import ('@/components/Input.vue')
    },
    {
      path: '/protocol',
      name: 'protocol',
      component: () =>
            import ('@/components/Protocol.vue')
    },
    {
      path: '/info',
      name: 'info',
      component: () =>
            import ('@/components/Info.vue')
    },
    {
      path: '/pdf',
      name: 'pdf',
      component: () =>
            import ('@/components/Pdf.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js